import { useCallback, useState } from "react";
import { ITaskUpdateRequest } from "../types";
import { useAppDispatch } from "../../../store";
import { assignTask } from "../../../acions/workTasks";

export const useAssignTask = (id: string, reload: () => void) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const assign = useCallback(
    async (req: ITaskUpdateRequest) => {
      try {
        setIsLoading(true);

        await Promise.resolve(dispatch(assignTask(id, req)));

        setIsLoading(false);

        reload();

        return 1;
      } catch {
        setIsLoading(false);

        return 0;
      }
    },
    [dispatch, id, reload],
  );

  return { isLoading, assign };
};
